var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramChannelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.266,
    cy: 1.077,
    r: 0.991,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff543e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -0.168,
    cy: 0.072,
    r: 0.443,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60f",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram-Logo.wine",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M24.007,0c-10.02,0-12.95.01-13.52.058a11.9,11.9,0,0,0-4.73,1.189A9.581,9.581,0,0,0,3,3.266,10.3,10.3,0,0,0,.22,9.1C.058,10.227.011,10.456,0,16.19c0,1.911,0,4.427,0,7.8C0,34,.012,36.933.06,37.5A12.06,12.06,0,0,0,1.2,42.14a10.111,10.111,0,0,0,6.553,5.354,17.023,17.023,0,0,0,3.485.462c.594.026,6.652.044,12.714.044s12.123-.007,12.7-.037a16.393,16.393,0,0,0,3.61-.473,10.049,10.049,0,0,0,6.553-5.365,11.863,11.863,0,0,0,1.131-4.548c.032-.414.046-7.007.046-13.593s-.015-13.168-.047-13.581A11.729,11.729,0,0,0,46.8,5.809a9.515,9.515,0,0,0-2.054-2.815A10.359,10.359,0,0,0,38.9.22C37.779.058,37.556.01,31.819,0Z",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M24.007,0c-10.02,0-12.95.01-13.52.058a11.9,11.9,0,0,0-4.73,1.189A9.581,9.581,0,0,0,3,3.266,10.3,10.3,0,0,0,.22,9.1C.058,10.227.011,10.456,0,16.19c0,1.911,0,4.427,0,7.8C0,34,.012,36.933.06,37.5A12.06,12.06,0,0,0,1.2,42.14a10.111,10.111,0,0,0,6.553,5.354,17.023,17.023,0,0,0,3.485.462c.594.026,6.652.044,12.714.044s12.123-.007,12.7-.037a16.393,16.393,0,0,0,3.61-.473,10.049,10.049,0,0,0,6.553-5.365,11.863,11.863,0,0,0,1.131-4.548c.032-.414.046-7.007.046-13.593s-.015-13.168-.047-13.581A11.729,11.729,0,0,0,46.8,5.809a9.515,9.515,0,0,0-2.054-2.815A10.359,10.359,0,0,0,38.9.22C37.779.058,37.556.01,31.819,0Z",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M35.844,17c-5.117,0-5.76.022-7.77.114a13.824,13.824,0,0,0-4.573.876A9.64,9.64,0,0,0,17.988,23.5a13.771,13.771,0,0,0-.875,4.575c-.09,2.01-.113,2.653-.113,7.772s.023,5.759.114,7.77a13.855,13.855,0,0,0,.875,4.575,9.644,9.644,0,0,0,5.51,5.514,13.836,13.836,0,0,0,4.574.876c2.01.091,2.652.114,7.769.114s5.758-.022,7.768-.114a13.844,13.844,0,0,0,4.576-.876,9.656,9.656,0,0,0,5.51-5.514,13.974,13.974,0,0,0,.875-4.575c.09-2.01.114-2.651.114-7.77s-.024-5.761-.114-7.772A13.968,13.968,0,0,0,53.7,23.5a9.642,9.642,0,0,0-5.512-5.512,13.868,13.868,0,0,0-4.577-.876C41.6,17.022,40.958,17,35.839,17Zm-1.69,3.4h1.69c5.031,0,5.627.018,7.614.108a10.43,10.43,0,0,1,3.5.649,6.245,6.245,0,0,1,3.575,3.577,10.417,10.417,0,0,1,.649,3.5c.09,1.987.11,2.584.11,7.614s-.02,5.627-.11,7.614a10.427,10.427,0,0,1-.649,3.5,6.25,6.25,0,0,1-3.575,3.575,10.392,10.392,0,0,1-3.5.649c-1.986.09-2.583.11-7.614.11s-5.628-.02-7.614-.11a10.45,10.45,0,0,1-3.5-.65,6.244,6.244,0,0,1-3.577-3.576,10.417,10.417,0,0,1-.649-3.5c-.09-1.987-.108-2.584-.108-7.617s.018-5.627.108-7.614a10.438,10.438,0,0,1,.649-3.5,6.246,6.246,0,0,1,3.577-3.578,10.407,10.407,0,0,1,3.5-.65c1.738-.079,2.412-.1,5.924-.106ZM45.9,23.526a2.262,2.262,0,1,0,2.261,2.262A2.261,2.261,0,0,0,45.9,23.526ZM35.844,26.169a9.678,9.678,0,1,0,9.676,9.679,9.678,9.678,0,0,0-9.676-9.679Zm0,3.4a6.283,6.283,0,1,1-6.281,6.283A6.282,6.282,0,0,1,35.844,29.566Z",
    transform: "translate(-11.847 -11.847)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramChannelIcon);
export default __webpack_public_path__ + "static/media/instagram-channel-icon.dccefe7bb68fbffcb1eda92beeae15d8.svg";
export { ForwardRef as ReactComponent };